import React from 'react';

import useVideoPlaybackTracking from '@hooks/useVideoPlaybackTracking';

interface FeaturedVideoProps {
  videoRef?: React.RefObject<HTMLVideoElement>;
  poster?: string;
  src?: string;
  title?: string;
}

const ExpertsBlockFeaturedVideo = ({ videoRef, poster, src, title }: FeaturedVideoProps) => {
  const { handleVideoEnd, handleVideoPause, handleVideoPlay, throttledHandleVideoTimeUpdate } =
    useVideoPlaybackTracking({ src, videoRef });

  return (
    <>
      <h2 className="text-center font-suisse-neue text-body-md sm:text-subheadline-sm">{title}</h2>
      <div className="aspect-[16/9] w-full">
        <video
          ref={videoRef}
          className="h-full w-full"
          onEnded={handleVideoEnd}
          onPause={handleVideoPause}
          onPlay={handleVideoPlay}
          onTimeUpdate={throttledHandleVideoTimeUpdate}
          poster={poster}
          preload="metadata"
          src={src}
          controls
          playsInline
        />
      </div>
    </>
  );
};

export default ExpertsBlockFeaturedVideo;
